class Drawer

  touch      : false
  button     : '.js-drawer-button'
  drawer     : '.js-drawer'
  accordion  : '.js-ch-accordion'
  overlay    : '.js-overlay'
  openedClass: 'drawer-opened'

  constructor: ->
    @$html      = $ 'html'
    @$body      = $ 'body'
    @$button    = $ @button
    @$drawer    = $ @drawer
    @$overlay   = $ @overlay
    @$accordion = @$drawer.find @accordion
    @devClick   = if window.ontouchstart is null then 'touchstart' else 'click'

    @$button.on @devClick, @openDrawer
    @$overlay.on @devClick, @closeDrawer
    @$accordion.on @devClick, @accordionToggle

  openDrawer: =>
    @$html.addClass @openedClass
    @$body.addClass @openedClass

  closeDrawer: =>
    @$html.removeClass @openedClass
    @$body.removeClass @openedClass

  accordionToggle: (event) ->
    elm    = event.currentTarget
    $next  = $ elm.nextElementSibling
    IF_FLG = $next.css 'display'
    return false if elm.flg
    elm.flg = true
    slideType = if IF_FLG is 'none' then 'slideDown' else 'slideUp'
    $next
      .velocity 'stop', false
      .velocity slideType,
        complete: ->
          elm.flg = false
    elm.classList.toggle 'is-ch-acc-active'

export default Drawer



// WEBPACK FOOTER //
// ./webpack/imports/view/drawer.coffee